// Muestra las contraseñas en inputs
const viewPassword = (params) => {
  params.forEach(param => {
    const input = document.querySelector(param.inputId)
    const icon = document.querySelector(param.iconId)

    if (input && icon) {
      icon.addEventListener('click', () => {
        icon.classList.contains('eye-hide') ? icon.classList.remove('eye-hide') : icon.classList.add('eye-hide')
        input.type = input.type === 'password' ? 'text' : 'password';
      })
    }
  })
}

export default viewPassword